import { render } from "./DrawerBlock.vue?vue&type=template&id=fd056744&scoped=true&ts=true"
import script from "./DrawerBlock.vue?vue&type=script&lang=ts"
export * from "./DrawerBlock.vue?vue&type=script&lang=ts"

import "./DrawerBlock.scss?vue&type=style&index=0&id=fd056744&lang=scss&scoped=true"

import exportComponent from "C:\\WORK\\MAPO\\hrm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd056744"]])

export default __exports__